// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2aSKg","label":"Completed_label__3ykWR"};